// Data comes from MQTT (AppContext) not from a backend.
// This file keeps fmt() and contact submission used by tab components.

import { db } from "./firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

/* Format a numeric value, returning "--" when no live data is present. */
export const fmt = (v, digits = 0, suffix = "") => {
  if (v === null || v === undefined || Number.isNaN(Number(v))) return "--";
  return Number(v).toFixed(digits) + suffix;
};

/* Send a contact message to Firestore */
export const sendContact = async (payload) => {
  await addDoc(collection(db, "contact_messages"), {
    ...payload,
    createdAt: serverTimestamp(),
  });
  return { ok: true };
};

/* Legacy stubs - components that import these get no-ops */
export const getTelemetry = async () => { throw new Error("Use AppContext.telemetry via MQTT"); };
export const getHistory   = async () => { throw new Error("Use AppContext.getHistory()"); };
export const sendCommand  = async () => { throw new Error("Use AppContext.sendCommand()"); };
